import { TabSkeleton } from '../Shared/TabSkeleton';

const EXPERIENCE_ROWS = ['avatar-row', 'input-row', 'input-row'] as const;

export const ExperienceTabSkeleton = () => (
  <TabSkeleton count={3} rows={EXPERIENCE_ROWS} headerButton />
);
